import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { IntentSettingAlertModalComponent } from './intent-setting-alert.component';
import {  MatDialogModule } from '@angular/material/dialog';
import { DisableAutocompleteDirectiveModule } from 'src/app/shared/directives';

@NgModule({
    imports: [
        DisableAutocompleteDirectiveModule,
        CommonModule,
        FontAwesomeModule,
        MatButtonModule,
        MatDialogModule,
    ],
    declarations: [IntentSettingAlertModalComponent],
    exports: [IntentSettingAlertModalComponent, MatDialogModule],
})
export class IntentSettingAlertModalModule {}
